import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import { approveUnapprovedUserApi,  getUnapprovedUsersListApi, getUnverifiedUsersListApi, registerGuestApi, resendUserVerificationLinkApi } from "../../services/api";
import { setUserState } from "../../redux/userManagementSlice";
import { setSnackbar } from "../../redux/messageSlice";
import { updateState } from "../../redux/commonSlice";
import { useReducer } from "react";



export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
  const guestReducer = useSelector(state=> state.guestReducer)
  const userReducer = useSelector(state=> state.userReducer)

  console.log(useReducer)

      
      const getUnverifiedUsersList = ( callback ) => {
        dispatch(setUserState({is_loading: true}))
        getUnverifiedUsersListApi() 
        .then((response) => {
          if(response?.data?.http_code === 200){
            console.log(response.data)
            dispatch(setUserState({ unverified_users:  response?.data?.data?.unverified_user_details}))
            callback && callback()
            setTimeout(() => {
              dispatch(setUserState({is_loading: false }))
            }, 500);
          }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
          dispatch(setUserState({is_loading: false}))
        }
        });
      }


      const getUnapprovedUsersList = ( callback ) => {
        dispatch(setUserState({is_loading: true}))
        getUnapprovedUsersListApi()
        .then((response) => {
          if(response?.data?.http_code === 200){
            console.log(response.data)
            dispatch(setUserState({ unapproved_users: response?.data?.data?.unapproved_user_details }))
            callback && callback()
            setTimeout(() => {
              dispatch(setUserState({is_loading: false }))
            }, 500);
          }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data
          showSnackBar(dispatch, errorObject)
          dispatch(setUserState({is_loading: false}))
        }
        });
      }

      const approveUser = (payload, callback ) => {
        dispatch(setUserState({user_action_loading: true}))
        approveUnapprovedUserApi(payload) 
        .then((response) => {
          dispatch(setUserState({user_action_loading: false}))
          if(response?.data?.http_code === 200){
            console.log(response.data)
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            getUnapprovedUsersList()
            getUnverifiedUsersList()
            callback && callback()
           
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          if(errorObject?.http_code === 403) {
            showSnackBar(dispatch, errorObject);
          } else {
            showSnackBar(dispatch, errorObject);
          }
          dispatch(setUserState({user_action_loading: false}))
        }
        });
      }

        const resendUnverifiedUserLink = (payload, callback ) => {
        dispatch(setUserState({resend_link_loading: true}))
        resendUserVerificationLinkApi(payload) 
        .then((response) => {
          dispatch(setUserState({resend_link_loading: false}))
          if(response?.data?.http_code === 200){
            console.log(response.data)
            dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
            callback && callback()
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
        }
        });
      }
    

  return { getUnapprovedUsersList, getUnverifiedUsersList, approveUser, resendUnverifiedUserLink};
}